import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SwitchUI from '../../../widgets/action/SwitchUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import DisbursementsNavUI from '../../../components/superUser/loanList/DisbursementsNavUI.js'
import './TotalDisbursementPage.css'

const TotalDisbursementPageUI = ({ context, errorList, accountDisbursedNRList, accountDisbursedRList, stateTotalOutstandingMap, response,
  checked, onShowDetailsChange, checkedAccount, onShowAccountDetailsChange, onDownloadAumReport, onRefreshClick, onTypeChange }) =>
  <SuperUserHomePageUI context={context} className='pg_su_disb_lst' topnav='accounts'
    headerText='Disbursements' centered={!accountDisbursedNRList && !errorList} dimension='w1600'
    page='disbursements' onTypeChange={onTypeChange}
  >
    {
      !accountDisbursedNRList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      accountDisbursedNRList &&
      <>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
              {/* <LinkWithSpinnerUI
                label='Download AUM Report'
                onClick={onDownloadAumReport}
                busy={onDownloadAumReportRequested}
              /> */}
              <IconButtonUI icon='icon-download' onClick={onDownloadAumReport} label='Download' />
              <span className='g_m_left_100 g_large'><b>Disbursements</b></span>
            </span>
          }
          right={
            <span className='g_flex_h g_m_right_100'>
              <span className='g_muted g_small g_m_right_50 g_m_left_50'>
                Show Accounts
              </span>
              <SwitchUI checked={checkedAccount} onChange={onShowAccountDetailsChange} />
              <span className='g_muted g_small g_m_right_50 g_m_left_50'>
                Show Loans
              </span>
              <SwitchUI checked={checked} onChange={onShowDetailsChange} />
            </span>
          }
        />

        <DisbursementsNavUI page='disbursements' />
      </>
    }
    {
      accountDisbursedNRList && response &&
      <BigNumberUI response={response} />
    }
    {
      stateTotalOutstandingMap && stateTotalOutstandingMap.length !== 0 &&
      <StateWiseAumUI stateTotalOutstandingMap={stateTotalOutstandingMap} response={response} />
    }
    {
      accountDisbursedNRList && accountDisbursedNRList.length !== 0 &&
      <AccountDisbursementUI
        accountDisbursedNRList={accountDisbursedNRList}
        accountDisbursedRList={accountDisbursedRList}
        onRefreshClick={onRefreshClick}
        response={response}
        checkedAccount={checkedAccount}
        checked={checked}
      />
    }
    {
      accountDisbursedNRList && accountDisbursedNRList.length === 0 &&
      <div className='g_m_top_50'>
        <EmptyListUI
          context={context}
          createEnabled={false}
          createDisabledMessageLabel='No disbursements yet'
        />
      </div>
    }
  </SuperUserHomePageUI>

const BigNumberUI = ({ response }) =>
  <CardUI className='g_m_bottom_100'>
    <div className='g_flex_h'>
      <div>
        <span className='g_flex_v g_text_center'>
          <span className='g_xxxlarge'><b>{response.totalDisbursementAmountF4}</b></span>
          <span>Disbursed since Inception</span>
        </span>
      </div>
      <div>
        <span className='g_flex_v g_text_center'>
          <span className='g_xxxlarge'><b>{response.totalPrincipalPaidF4}</b></span>
          <span>Principal Paid Back</span>
        </span>
      </div>
      <div>
        <span className='g_flex_v g_text_center'>
          <span className='g_xxxlarge'><b>{response.totalEarningsF4}</b></span>
          <span>Total Earned by Clime</span>
        </span>
      </div>
      <div>
        <span className='g_flex_v g_text_center'>
          <span className='g_xxxlarge'><b>{response.totalOutstandingF4}</b></span>
          <span>Total Outstanding (AUM)</span>
        </span>
      </div>
    </div>
  </CardUI>

const StateWiseAumUI = ({ stateTotalOutstandingMap, response }) =>
  <CardUI className='g_m_bottom_100' title='Statewise Outstanding'>
    <div style={{ 'display': 'flex', flexWrap: 'wrap' }}>
      {
        Array.from(Object.entries(stateTotalOutstandingMap)).map(([key, value]) => (
          <div style={{ flex: '1 1 25%', paddingRight: '40px' }}>
            <span className='g_flex_h'>
              <span className='g_small'><b>{key}</b></span>
              <span className='g_small'>{value}</span>
            </span>
          </div>
        ))
      }
      {/* add extra <div>s so that last row divs don't span whole width */}
      {
        Object.entries(stateTotalOutstandingMap).length % 4 === 1 &&
        <>
          <div style={{ flex: '1 1 25%', paddingRight: '40px' }} />
          <div style={{ flex: '1 1 25%', paddingRight: '40px' }} />
          <div style={{ flex: '1 1 25%', paddingRight: '40px' }} />
        </>
      }
      {
        Object.entries(stateTotalOutstandingMap).length % 4 === 2 &&
        <>
          <div style={{ flex: '1 1 25%', paddingRight: '40px' }} />
          <div style={{ flex: '1 1 25%', paddingRight: '40px' }} />
        </>
      }
      {
        Object.entries(stateTotalOutstandingMap).length % 4 === 3 &&
        <>
          <div style={{ flex: '1 1 25%', paddingRight: '40px' }} />
        </>
      }
    </div>

    <div className='g_flex_h g_flex_left g_m_top_50'>
      <span className='g_m_right_100'><b>Total</b></span>
      <span><b>{response.stateOutstandingTotalF4}</b></span>
    </div>
  </CardUI >


const AccountDisbursementUI = ({ accountDisbursedNRList, accountDisbursedRList, response, checkedAccount, checked }) =>
  <div>
    <CardUI title='Non retail disbursments' className='g_m_bottom_100'>
      <table className='g_small'>
        <thead className='g_sticky'>
          <tr className='head'>
            <td></td>
            <th className='g_p_left_100'>Account/Loan</th>
            <th className='g_p_left_100'>Outstanding</th>
            <th className='g_p_left_100'>Disbursed</th>
            <th className='g_p_left_100'>Fee Paid</th>
            <th className='g_p_left_100'>Interest Paid</th>
            <th className='g_p_left_100'>Principal Paid</th>
            <th className='g_p_left_100'>Tax Paid</th>
            <th className='g_p_left_100'>Dsra Dip Interest</th>
            <th className='g_p_left_100'>Penal Charge</th>
            <th className='g_p_left_100'>Total Paid</th>
            <th className='g_p_left_100'>Total Earned</th>
          </tr>
        </thead>
        <tbody>
          {
            checkedAccount && accountDisbursedNRList.map((account, i) =>
              <>
                {
                  !account.retailLoan &&
                  <tr className='acc' key={i}>
                    <td className='left'>{i + 1}.</td>
                    <td className='left g_no_wrap_2'>{account.disbursedAmountF4 == "0" ? account.accountName + " (R.F)" : account.accountName}</td>
                    <td className='g_text_right amt'>{account.outstandingF4}</td>
                    <td className='g_text_right amt'>{account.disbursedAmountF4}</td>
                    <td className='g_text_right amt'>{account.feePaidF4}</td>
                    <td className='g_text_right amt'>{account.interestPaidF4}</td>
                    <td className='g_text_right amt'>{account.principalPaidF4}</td>
                    <td className='g_text_right amt'>{account.taxPaidF4}</td>
                    <td className='g_text_right amt'>{account.dsraDipIntPaidF4}</td>
                    <td className='g_text_right amt'>{account.defaultIntPaidF4}</td>
                    <td className='g_text_right amt'>{account.totalPaidF4}</td>
                    <td className='g_text_right amt'>{account.totalEarningsF4}</td>
                  </tr>
                }
                {
                  checkedAccount && checked &&
                  account.loanDisbursedList.map((loan, j) =>
                    <>
                      {
                        !loan.retailLoan &&
                        <tr className='loan' key={i * 100 + j}>
                          <td className='left'>{i + 1}.{j + 1}</td>
                          <td className='left g_no_wrap_2'>
                            <span className='g_flex_v'>{loan.loanName}<span className='g_muted g_small'>{loan.status}</span></span>
                          </td>
                          <td className='g_text_right amt'>{loan.outstandingF4}</td>
                          <td className='g_text_right amt'><span className='g_flex_v'>{loan.disbursedAmountF4}<span className='g_muted g_small'>{loan.yearMonth}</span></span></td>
                          <td className='g_text_right amt'><span className='g_flex_v'>{loan.feePaidF4}<span className='g_muted g_small'>{loan.feePercent}%</span></span></td>
                          <td className='g_text_right amt'>{loan.interestPaidF4}</td>
                          <td className='g_text_right amt'>{loan.principalPaidF4}</td>
                          <td className='g_text_right amt'>{loan.taxPaidF4}</td>
                          <td className='g_text_right amt'>{loan.dsraDipIntPaidF4}</td>
                          <td className='g_text_right amt'>{loan.defaultIntPaidF4}</td>
                          <td className='g_text_right amt'>{loan.totalPaidF4}</td>
                          <td className='g_text_right amt'>{loan.totalEarningsF4}</td>
                        </tr>
                      }
                    </>
                  )
                }
              </>
            )
          }
          {
            !checkedAccount && checked && flattenLoanList(accountDisbursedNRList).map((loan, j) =>
              <>
                {
                  !loan.retailLoan &&
                  <tr className='loan' key={j}>
                    <td className='left'>{j + 1}</td>
                    <td className='left g_no_wrap_2'>
                      <span className='g_flex_v'>{loan.loanName}<span className='g_muted g_small'>{loan.status}</span></span>
                    </td>
                    <td className='g_text_right amt'>{loan.outstandingF4}</td>
                    <td className='g_text_right amt'><span className='g_flex_v'>{loan.disbursedAmountF4}<span className='g_muted g_small'>{loan.yearMonth}</span></span></td>
                    <td className='g_text_right amt'><span className='g_flex_v'>{loan.feePaidF4}<span className='g_muted g_small'>{loan.feePercent}%</span></span></td>
                    <td className='g_text_right amt'>{loan.interestPaidF4}</td>
                    <td className='g_text_right amt'>{loan.principalPaidF4}</td>
                    <td className='g_text_right amt'>{loan.taxPaidF4}</td>
                    <td className='g_text_right amt'>{loan.dsraDipIntPaidF4}</td>
                    <td className='g_text_right amt'>{loan.defaultIntPaidF4}</td>
                    <td className='g_text_right amt'>{loan.totalPaidF4}</td>
                    <td className='g_text_right amt'>{loan.totalEarningsF4}</td>
                  </tr>
                }
              </>
            )
          }
          <tr className='foot'>
            <td></td>
            <td className='left'>Total</td>
            <td>{response.outstandingNRF4}</td>
            <td>{response.disbursedAmountNRF4}</td>
            <td>{response.feePaidNRF4}</td>
            <td>{response.interestPaidNRF4}</td>
            <td>{response.principalPaidNRF4}</td>
            <td>{response.taxPaidNRF4}</td>
            <td>{response.dsraDipIntPaidNRF4}</td>
            <td>{response.defaultIntPaidNRF4}</td>
            <td>{response.totalPaidNRF4}</td>
            <td>{response.totalEarningsNRF4}</td>
          </tr>
        </tbody>
      </table>
    </CardUI>
    <CardUI title='Retail disbursments' className='g_m_bottom_100'>
      <table className='g_small'>
        <thead className='g_sticky'>
          <tr className='head'>
            <td></td>
            <th className='g_p_left_100'>Account/Loan</th>
            <th className='g_p_left_100'>Outstanding</th>
            <th className='g_p_left_100'>Disbursed</th>
            <th className='g_p_left_100'>Fee Paid</th>
            <th className='g_p_left_100'>Interest Paid</th>
            <th className='g_p_left_100'>Principal Paid</th>
            <th className='g_p_left_100'>Tax Paid</th>
            <th className='g_p_left_100'>Dsra Dip Interest</th>
            <th className='g_p_left_100'>Penal Charge</th>
            <th className='g_p_left_100'>Total Paid</th>
            <th className='g_p_left_100'>Total Earned</th>
          </tr>
        </thead>
        <tbody>
          {
            checkedAccount && accountDisbursedRList.map((account, i) =>
              <>
                {
                  account.retailLoan &&
                  <tr className='acc' key={i}>
                    <td className='left'>{i + 1}.</td>
                    <td className='left g_no_wrap_2'>{account.accountName}</td>
                    <td className='g_text_right amt'>{account.outstandingF4}</td>
                    <td className='g_text_right amt'>{account.disbursedAmountF4}</td>
                    <td className='g_text_right amt'>{account.feePaidF4}</td>
                    <td className='g_text_right amt'>{account.interestPaidF4}</td>
                    <td className='g_text_right amt'>{account.principalPaidF4}</td>
                    <td className='g_text_right amt'>{account.taxPaidF4}</td>
                    <td className='g_text_right amt'>{account.dsraDipIntPaidF4}</td>
                    <td className='g_text_right amt'>{account.defaultIntPaidF4}</td>
                    <td className='g_text_right amt'>{account.totalPaidF4}</td>
                    <td className='g_text_right amt'>{account.totalEarningsF4}</td>
                  </tr>
                }
                {
                  checkedAccount && checked &&
                  account.loanDisbursedList.map((loan, j) =>
                    <>
                      {
                        loan.retailLoan &&
                        <tr className='loan' key={i * 100 + j}>
                          <td className='left'>{i + 1}.{j + 1}</td>
                          <td className='left g_no_wrap_2'>
                            <span className='g_flex_v'>{loan.loanName}<span className='g_muted g_small'>{loan.status}</span></span>
                          </td>
                          <td className='g_text_right amt'>{loan.outstandingF4}</td>
                          <td className='g_text_right amt'><span className='g_flex_v'>{loan.disbursedAmountF4}<span className='g_muted g_small'>{loan.yearMonth}</span></span></td>
                          <td className='g_text_right amt'><span className='g_flex_v'>{loan.feePaidF4}<span className='g_muted g_small'>{loan.feePercent}%</span></span></td>
                          <td className='g_text_right amt'>{loan.interestPaidF4}</td>
                          <td className='g_text_right amt'>{loan.principalPaidF4}</td>
                          <td className='g_text_right amt'>{loan.taxPaidF4}</td>
                          <td className='g_text_right amt'>{loan.dsraDipIntPaidF4}</td>
                          <td className='g_text_right amt'>{loan.defaultIntPaidF4}</td>
                          <td className='g_text_right amt'>{loan.totalPaidF4}</td>
                          <td className='g_text_right amt'>{loan.totalEarningsF4}</td>
                        </tr>
                      }
                    </>
                  )
                }
              </>
            )
          }
          {
            !checkedAccount && checked && flattenLoanList(accountDisbursedRList).map((loan, j) =>
              <>
                {
                  loan.retailLoan &&
                  <tr className='loan' key={j}>
                    <td className='left'>{j + 1}</td>
                    <td className='left g_no_wrap_2'>
                      <span className='g_flex_v'>{loan.loanName}<span className='g_muted g_small'>{loan.status}</span></span>
                    </td>
                    <td className='g_text_right amt'>{loan.outstandingF4}</td>
                    <td className='g_text_right amt'><span className='g_flex_v'>{loan.disbursedAmountF4}<span className='g_muted g_small'>{loan.yearMonth}</span></span></td>
                    <td className='g_text_right amt'><span className='g_flex_v'>{loan.feePaidF4}<span className='g_muted g_small'>{loan.feePercent}%</span></span></td>
                    <td className='g_text_right amt'>{loan.interestPaidF4}</td>
                    <td className='g_text_right amt'>{loan.principalPaidF4}</td>
                    <td className='g_text_right amt'>{loan.taxPaidF4}</td>
                    <td className='g_text_right amt'>{loan.dsraDipIntPaidF4}</td>
                    <td className='g_text_right amt'>{loan.defaultIntPaidF4}</td>
                    <td className='g_text_right amt'>{loan.totalPaidF4}</td>
                    <td className='g_text_right amt'>{loan.totalEarningsF4}</td>
                  </tr>
                }
              </>
            )
          }
          <tr className='foot'>
            <td></td>
            <td className='left'>Total</td>
            <td>{response.outstandingRF4}</td>
            <td>{response.disbursedAmountRF4}</td>
            <td>{response.feePaidRF4}</td>
            <td>{response.interestPaidRF4}</td>
            <td>{response.principalPaidRF4}</td>
            <td>{response.taxPaidRF4}</td>
            <td>{response.dsraDipIntPaidRF4}</td>
            <td>{response.defaultIntPaidRF4}</td>
            <td>{response.totalPaidRF4}</td>
            <td>{response.totalEarningsRF4}</td>
          </tr>
        </tbody>
      </table>
    </CardUI>
  </div>

function flattenLoanList(accountDisbursedList) {
  const allLoans = [];

  accountDisbursedList.forEach(account => {
    account.loanDisbursedList.forEach(loan => {
      allLoans.push(loan);
    });
  });

  return allLoans;
}

export default TotalDisbursementPageUI
